var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-card",class:[
    {'flow-card--selected': _vm.selected},
    {'flow-card--disabled': _vm.card.disabled},
    ("flow-card--" + _vm.color),
    _vm.card.itemClass ]},[_c('i',{staticClass:"flow-card__icon",class:_vm.card.iconClass,attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('h4',{staticClass:"flow-card__title"},[_vm._v(_vm._s(_vm.card.name))]),_vm._v(" "),_c('p',{staticClass:"flow-card__description"},[_vm._v("\n    "+_vm._s(_vm.card.description)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }